import _interopRequireWildcard from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable */
import Vue from 'vue';
import Router from 'vue-router';

/* Layout */
import Layout from '@/layout';
Vue.use(Router);

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

// router example
// {
//   path: '/example',
//   component: Layout,
//   redirect: '/example/table',
//   name: 'Example',
//   meta: { title: 'navbar.TABLE', icon: 'el-icon-s-help' },
//   children: [
//     {
//       path: 'table',
//       name: 'Table',
//       title: 'navbar.FIRST_TABLE',
//       component: () => import('@/views/table/index'),
//       meta: { title: 'Table', icon: 'table' }
//     },
//     {
//       path: 'tree',
//       name: 'Tree',
//       title: 'navbar.TREE',
//       component: () => import('@/views/tree/index'),
//       meta: { title: 'Tree', icon: 'tree' }
//     }
//   ]
// },
export var constantRoutes = [{
  path: '/redirect',
  component: Layout,
  hidden: true,
  children: [{
    path: '/redirect/:path*',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/redirect/index'));
      });
    }
  }]
}, {
  path: '/login',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/login/index'));
    });
  },
  hidden: true
}, {
  path: '/404',
  component: Layout,
  children: [{
    path: '/404',
    title: '404',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/404'));
      });
    },
    meta: {
      title: '404',
      icon: 'abolish'
    },
    hidden: true
  }]
  // component: () => import('@/views/404'),
  // hidden: true
}, {
  path: '/',
  component: Layout,
  redirect: '/dashboard',
  children: [{
    path: 'dashboard',
    name: 'dashboard',
    title: 'navbar.HOME',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/firstPage/home.vue'));
      });
    },
    meta: {
      title: '',
      icon: 'dashboard'
    },
    hidden: true
  }]
}, {
  path: '/combinedSearch',
  component: Layout,
  children: [{
    path: '/',
    name: 'combinedSearch',
    title: '综合搜索',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/combinedsearch/home.vue'));
      });
    },
    meta: {
      title: '综合搜索',
      icon: 'dashboard'
    },
    hidden: true
  }]
}, {
  path: '/checkToken',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/views/system/checkToken'));
    });
  },
  hidden: true
}, {
  path: '/report',
  component: Layout,
  children: [{
    path: '/report/abolish',
    title: '立改废',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '立改废',
      icon: 'abolish',
      sysId: 'LC_IE'
    },
    hidden: true
  }, {
    path: '/report/suggestAndReply',
    title: '建议反馈',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '建议反馈',
      icon: 'suggestAndReply',
      sysId: 'LC_IE'
    },
    hidden: true
  }, {
    path: '/report/catalogueDetail',
    title: '立改废',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度目录',
      icon: 'catalogueDetail',
      sysId: 'LC_IE'
    },
    hidden: true
  }]
}, {
  path: '/flexmonsterdashboard',
  component: Layout,
  children: [{
    path: '/flexmonsterdashboard',
    title: 'flexmonsterdashboard',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '报表统计',
      icon: 'flexmonsterdashboard',
      sysId: 'LC_IE'
    },
    hidden: true
  }]
  // component: () => import('@/views/404'),
  // hidden: true
}, {
  path: '/legalqa',
  component: Layout,
  title: '批量属性维护',
  children: [{
    path: '/legalqa/portal-home',
    title: '常见问题资源检索',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '常见问题资源检索',
      icon: 'qacoupleu',
      sysId: 'LC_FAQ'
    },
    hidden: true
  }, {
    path: '/legalqa/management',
    title: '常见问题管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '常见问题管理',
      icon: 'management',
      sysId: 'LC_FAQ'
    },
    hidden: true
  }, {
    path: '/legalqa/reply',
    title: '问题评论管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '问题评论管理',
      icon: 'reply',
      sysId: 'LC_FAQ'
    },
    hidden: true
  }]
}, {
  path: '/approveModification',
  component: Layout,
  title: '批量属性维护',
  children: [{
    path: '/',
    title: '批量属性维护',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '批量属性维护',
      icon: 'attrModification',
      sysId: 'LC_IE'
    },
    hidden: true
  }]
}, {
  path: '/instUploadManage',
  component: Layout,
  title: '制度上传管理',
  children: [{
    path: '/',
    title: '制度上传管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度上传管理',
      icon: 'instUploadManage',
      sysId: 'LC_IE'
    },
    hidden: true
  }]
}, {
  path: '/system',
  name: 'system',
  component: Layout,
  meta: {
    title: '系统管理',
    icon: 'el-icon-s-help',
    keepAlive: true
  },
  children: [
  // {
  //   path: "/system/role",
  //   title: "系统角色",
  //   component: () => import("@/views/system/role"),
  //   meta: { title: "系统角色", icon: "table" }
  // },
  {
    path: '/system/permission',
    title: '我的权限',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/permission/home'));
      });
    },
    meta: {
      title: '我的权限',
      icon: 'table'
    }
  }, {
    path: '/system/permission/apply',
    title: '权限申请',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/permission/apply'));
      });
    },
    meta: {
      title: '权限申请',
      icon: 'table'
    }
  }, {
    path: '/system/role',
    title: '角色管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/role/home'));
      });
    },
    meta: {
      title: '角色管理',
      icon: 'table'
    }
  }, {
    path: '/system/role/edit',
    title: '角色编辑',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/role/edit'));
      });
    },
    meta: {
      title: '角色编辑'
    }
  }, {
    path: '/system/role/detail/:roleId/:systemId',
    title: '角色详情',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/role/detail'));
      });
    },
    meta: {
      title: '角色详情'
    }
  }, {
    path: '/system/editRole',
    title: '编辑角色',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/editRole'));
      });
    },
    meta: {
      title: '系统角色',
      icon: 'table'
    }
  }, {
    path: '/system/power',
    title: '系统权限',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/power'));
      });
    },
    meta: {
      title: '系统权限',
      icon: 'table'
    }
  }, {
    path: '/system/user',
    title: '系统用户',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/user'));
      });
    },
    meta: {
      title: '系统用户',
      icon: 'tree'
    }
  }, {
    path: '/system/usergroup',
    title: '用户群组',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/usergroup/home'));
      });
    },
    meta: {
      title: '用户群组',
      icon: 'tree'
    }
  }, {
    path: '/system/addusergroup',
    title: '用户群组',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/usergroup/editgroup'));
      });
    },
    meta: {
      title: '用户群组',
      icon: 'tree'
    }
  }, {
    path: '/system/viewusergroup',
    title: '用户群组',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/usergroup/view'));
      });
    },
    meta: {
      title: '用户群组',
      icon: 'tree'
    }
  }, {
    path: '/system/subSys',
    title: '子系统管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/subSys'));
      });
    },
    meta: {
      title: '子系统管理'
    }
  }, {
    path: '/system/dataDictionary',
    title: '数据字典',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/dataDictionary'));
      });
    },
    meta: {
      title: '数据字典'
    }
  }, {
    path: '/system/virtualDict',
    title: '虚拟字典',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/inventedDict'));
      });
    },
    meta: {
      title: '虚拟字典'
    }
  }, {
    path: '/system/routesmanage',
    title: '系统网关',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/routesmanage'));
      });
    },
    meta: {
      title: '系统网关'
    }
  }, {
    path: '/system/orgManage',
    title: '系统机构',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/orgManage'));
      });
    },
    meta: {
      title: '系统机构'
    }
  }, {
    path: '/system/userManage',
    title: '系统用户',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/userManage'));
      });
    },
    meta: {
      title: '系统用户'
    }
  }, {
    path: '/system/resourcemanage',
    title: '系统资源',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/resourcemanage'));
      });
    },
    meta: {
      title: '系统资源'
    }
  }, {
    path: '/system/timedTask',
    title: '定时器',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/resource/timedTask'));
      });
    },
    meta: {
      title: '定时器'
    }
  }, {
    path: '/system/systemlogmanage',
    title: '日志管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/systemlogmanage'));
      });
    },
    meta: {
      title: '日志管理'
    }
  }, {
    path: '/system/globalconfig',
    title: '全局配置',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/globalconfig'));
      });
    },
    meta: {
      title: '全局配置'
    }
  }, {
    path: '/system/addUser',
    title: '新增用户',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/addUser'));
      });
    },
    meta: {
      title: '新增用户'
    }
  }, {
    path: '/system/userRule',
    title: '用户筛选规则管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/userRule'));
      });
    },
    meta: {
      title: '用户筛选规则管理',
      keepAlive: false
    }
  }, {
    path: '/system/editRule',
    name: 'editRule',
    title: '用户筛选规则管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/editRule'));
      });
    },
    meta: {
      title: '编辑筛选规则',
      keepAlive: true
    }
  }, {
    path: '/system/preViewRule',
    name: 'preViewRule',
    title: '用户筛选规则管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/user/previewRule'));
      });
    },
    meta: {
      title: '预览成员',
      keepAlive: false
    }
  }, {
    path: '/system/helpDoc',
    name: 'helpDoc',
    title: '帮助文档管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/helpDoc'));
      });
    },
    meta: {
      title: '帮助文档',
      keepAlive: false
    }
  }, {
    path: '/system/helpDoc/nomalHelpDoc',
    name: 'helpDoc',
    title: '帮助文档查看',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/helpDoc/nomalHelpDoc'));
      });
    },
    meta: {
      title: '帮助文档',
      keepAlive: false
    }
  }, {
    path: '/system/helpDoc/helpPdf',
    name: 'helpPdf',
    title: '帮助文档预览',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/helpDoc/helpPdf'));
      });
    },
    meta: {
      title: '帮助文档',
      keepAlive: false
    }
  }, {
    path: '/system/collect',
    name: 'collect',
    title: '我的收藏',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/collect'));
      });
    },
    meta: {
      title: '我的收藏',
      keepAlive: false
    }
  }, {
    path: '/system/collectDetail',
    name: 'collectDetail',
    title: '我的收藏',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/system/collect/collectDetail'));
      });
    },
    meta: {
      title: '收藏详情',
      keepAlive: false
    }
  }]
}, {
  path: '/resource',
  redirect: '/resource',
  component: Layout,
  meta: {
    title: '系统管理',
    icon: 'el-icon-s-help'
  },
  children: [{
    path: '/resource/messageAgent',
    title: '我的任务',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/resource/messageAgent'));
      });
    },
    meta: {
      title: '我的任务'
    }
  }, {
    path: '/resource/manage',
    title: '资源管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/resource/manage'));
      });
    },
    meta: {
      title: '资源管理'
    }
  }]
},
// {
//   path: '/home',
//   title: '首页',
//   component: () => import('@/views/Home'),
// },
{
  path: '/',
  component: Layout,
  children: [{
    path: '/qaStream',
    name: 'qaStream',
    title: '合规政策问答',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/firstPage/qaStream.vue'));
      });
    },
    meta: {
      title: '合规政策问答'
    },
    hidden: true
  }]
}, {
  path: '/firstPage',
  component: Layout,
  children: [{
    path: '/firstPage/home',
    title: '首页',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/firstPage/home.vue'));
      });
    },
    meta: {
      title: '首页'
    },
    hidden: true
  }]
}, {
  path: '/manage',
  component: Layout,
  children: [{
    path: '/manage/improvePlan',
    title: '改进计划',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '改进计划'
    },
    hidden: true
  }, {
    path: '/manage/suggestCollection',
    title: '建议收集',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '建议收集',
      icon: 'suggestCollection'
    },
    hidden: true
  }, {
    path: '/manage/naturalAbolishment',
    title: '自然废止到期',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '自然废止到期',
      icon: 'naturalAbolishment'
    },
    hidden: true
  }, {
    path: '/manage/institutionalImpact',
    title: '制度影响报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度影响报表',
      icon: 'institutionalImpact'
    },
    hidden: true
  }, {
    path: '/manage/institutionalRelevance',
    title: '制度关联报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度关联报表',
      icon: 'institutionalRelevance'
    },
    hidden: true
  }, {
    path: '/report/improvePlanReport',
    name: 'Plan',
    title: '制度计划报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度计划报表',
      icon: 'improvePlanReport'
    },
    hidden: true
  }, {
    path: '/report/improvePlanDetailReport',
    name: 'Plan',
    title: '制度计划详细报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度计划详细报表',
      icon: 'improvePlanDetailReport'
    },
    hidden: true
  }, {
    path: '/report/instPlanDetailReport',
    title: '制度明细列表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度明细列表',
      icon: 'instPlanDetailReport'
    },
    hidden: true
  },
  // 外规内化任务
  {
    path: '/manage/home',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '智能合规平台'
    },
    hidden: true
  }, {
    path: '/manage/managehome',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '智能合规平台'
    },
    hidden: true
  }, {
    path: '/manage/taskProcess',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '智能合规平台'
    },
    hidden: true
  }, {
    path: '/manage/taskDetail',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '智能合规平台'
    },
    hidden: true
  }, {
    path: '/manage/regDetail',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '单项外规详情-方圆合规'
    },
    hidden: true
  }, {
    path: '/manage/retry',
    title: '智能合规平台',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '发起任务-方圆合规'
    },
    hidden: true
  }]
},
// 外规首页
{
  path: '/systemDetails',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '法规详情-方圆合规'
  },
  hidden: true
}, {
  path: '/uploadSystemEditor',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '上传编辑-方圆合规'
  },
  hidden: true
}, {
  path: '/uploadSystemRelevance',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '上传确认-方圆合规'
  },
  hidden: true
}, {
  path: '/compareInst',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '法规对比-方圆合规'
  },
  hidden: true
},
// 同业罚单详情
{
  path: '/detailPage',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '罚单详情-方圆合规'
  },
  hidden: true
},
// 制度报表统计
{
  path: '/instReport',
  title: '智能合规平台',
  component: function component() {
    return Promise.resolve().then(function () {
      return _interopRequireWildcard(require('@/layout/components/iframeindex'));
    });
  },
  meta: {
    title: '制度报表统计-数智合规'
  },
  hidden: true
}, {
  path: '/manage/instView',
  name: 'instView',
  title: '制度视图',
  component: Layout,
  children: [{
    path: '/',
    title: '制度视图',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度视图'
    },
    hidden: true
  }, {
    path: 'maintain',
    title: '视图维护',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '视图维护'
    },
    hidden: true
  }, {
    path: 'viewAdd',
    title: '创建视图',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '创建视图'
    },
    hidden: true
  }, {
    path: 'exhibit',
    title: '制度视图展示',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度视图展示'
    },
    hidden: true
  }]
}, {
  path: '/manage/systemHandover',
  name: 'systemHandover',
  title: '制度交接',
  component: Layout,
  children: [{
    path: '/',
    title: '制度交接',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度交接'
    },
    hidden: true
  }, {
    path: 'handoverCreate',
    title: '制度交接创建',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度交接创建'
    },
    hidden: true
  }, {
    path: 'handoverDetails',
    title: '制度交接详情',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度交接详情'
    },
    hidden: true
  }]
}, {
  path: '/systemCatalogue',
  name: 'systemCatalogue',
  title: '制度目录管理',
  component: Layout,
  children: [{
    path: '/',
    title: '制度目录',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度目录'
    },
    hidden: true
  }]
}, {
  path: '/manage/systemCatalogueManage',
  name: 'systemCatalogueManage',
  title: '制度目录管理',
  component: Layout,
  children: [{
    path: '/',
    title: '制度目录管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度目录管理'
    },
    hidden: true
  }]
}, {
  path: '/systemClauseManage',
  name: 'systemClauseManage',
  title: '内规条款管理',
  component: Layout,
  children: [{
    path: '/',
    title: '内规条款管理',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '内规条款管理'
    },
    hidden: true
  }]
}, {
  path: '/manage/systemReview',
  name: 'systemReview',
  title: '制度评审',
  component: Layout,
  children: [{
    path: '/',
    title: '制度评审',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度评审'
    },
    hidden: true
  }, {
    path: 'reviewFile',
    title: '制度评审正文',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度评审正文'
    },
    hidden: true
  }, {
    path: 'reviewCreate',
    title: '制度评审创建',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '制度评审创建'
    },
    hidden: true
  }, {
    path: 'departmentTable',
    title: '拟稿部门统计报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '拟稿部门统计报表'
    },
    hidden: true
  }, {
    path: 'digitalTable',
    title: '数字明细报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '数字明细报表'
    },
    hidden: true
  }, {
    path: 'issueBankTable',
    title: '受理行统计报表',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '受理行统计报表'
    },
    hidden: true
  }, {
    path: 'checkProcess',
    title: '流程审核',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '流程审核'
    },
    hidden: true
  }, {
    path: 'pdf',
    title: '文件预览',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/layout/components/iframeindex'));
      });
    },
    meta: {
      title: '文件预览'
    },
    hidden: true
  }]
}, {
  path: '/form',
  component: Layout,
  children: [{
    path: 'index',
    name: 'Form',
    title: 'navbar.FORM',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/form/index'));
      });
    },
    meta: {
      title: 'Form',
      icon: 'form'
    }
  }]
}, {
  path: '/nested',
  component: Layout,
  redirect: '/nested/menu1',
  name: 'Nested',
  meta: {
    title: 'navbar.MENU',
    icon: 'nested'
  }
}, {
  path: 'external-link',
  component: Layout,
  children: [{
    title: 'navbar.LINK',
    path: 'https://panjiachen.github.io/vue-element-admin-site/#/',
    meta: {
      title: 'External Link ',
      icon: 'link'
    }
  }]
}, {
  path: '/sqlManage',
  component: Layout,
  children: [{
    title: 'sqlManage',
    path: '/',
    meta: {
      title: 'sqlManage',
      icon: 'link'
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/sqlPage/home'));
      });
    }
  }]
}, {
  path: '/devBtns',
  component: Layout,
  children: [{
    title: 'devBtns',
    path: '/',
    meta: {
      title: 'devBtns',
      icon: 'link'
    },
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/devBtns/devBtns.vue'));
      });
    }
  }]
},
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    mode: 'history',
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes,
    base: "/".concat(process.env.VUE_APP_SERVER_PREFIX)
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;